import { API_BASE } from '../config/api';

const handleResponse = async (response, fallbackMessage = 'Unable to load tournament admins.') => {
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const message = data.error || data.message || fallbackMessage;
    throw new Error(message);
  }

  return data;
};

export const createTournamentAdmin = async (payload, token) => {
  const response = await fetch(`${API_BASE}/api/communities/tournament-admins`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  return handleResponse(response, 'Unable to create tournament admin.');
};

export const updateTournamentAdmin = async (adminId, payload, token) => {
  const response = await fetch(`${API_BASE}/api/communities/tournament-admins/${adminId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  return handleResponse(response, 'Unable to update tournament admin.');
};

export const deleteTournamentAdmin = async (adminId, token) => {
  const response = await fetch(`${API_BASE}/api/communities/tournament-admins/${adminId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to delete tournament admin.');
};

export const unassignCommunityTournamentAdminRole = async (communityId, userId, token) => {
  const response = await fetch(`${API_BASE}/api/communities/${communityId}/roles/tournament-admin/${userId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to remove tournament admin role.');
};

export const unassignCommunityDepartmentAdminRole = async (communityId, userId, token) => {
  const response = await fetch(`${API_BASE}/api/communities/${communityId}/roles/department-admin/${userId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to remove department admin role.');
};
